export default "__VITE_ASSET__CiTfqnAO__"